import type { Id } from "@convex/_generated/dataModel";
import { createFileRoute } from "@tanstack/react-router";
import { useEmployee } from "@/features/employee/use-employee";
import { MemoryBrowser } from "@/features/memory/memory-browser";

export const Route = createFileRoute("/_app/_main/team/$employeeId/memory")({ component: MemoryTab });

function MemoryTab() {
  const employeeId = Route.useParams().employeeId as Id<"employees">;
  const employee = useEmployee(employeeId);
  // Null is "not on this team", which the profile around this tab already says.
  if (employee === undefined || employee === null) return null;
  return (
    <MemoryBrowser
      key={employeeId}
      reviewer={{ id: employeeId, name: employee.name }}
      footer={`${employee.name} edits these notes itself. Anything you change here, it reads before its next task.`}
      sections={[
        { key: "employee", label: `${employee.name}'s notes`, owner: { scope: "employee", employeeId }, icon: "note" },
        { key: "team", label: "Team notebook", owner: { scope: "team", employeeId: null }, icon: "people" },
      ]}
      skillsFor={employeeId}
    />
  );
}
